import { object, string, z } from 'zod';

export const ImageUploadSchema = object({
  token: string(),
});

export type ImageUploadResponse = z.infer<typeof ImageUploadSchema>;
